import { Component, OnInit } from "@angular/core";
import { ApiService } from "src/app/api.service";
import { TreeNode } from "@circlon/angular-tree-component";
import { APIResults } from "src/app/sharedinterfaces";
import { ChartingService } from "src/app/charting.service";

@Component({
	selector: "app-thresholding",
	templateUrl: "./thresholding.component.html",
	styleUrls: ["./thresholding.component.scss"]
})
export class ThresholdingComponent implements OnInit {
	public treenodes: any[];
	public selectedConfig: AssetConfigWithAssets;
	public thresholdError: string;
	public thresholdComponents: APIResults.ComponentThreshold[] = null;
	public selectedComponent: APIResults.ComponentThreshold;
	public boxPlotOptions: Highcharts.Options;
	public newConfig: string;

	constructor(public api: ApiService, public charting: ChartingService) { }

	async ngOnInit() {
		await this.UpdateTree();
	}

	public async UpdateTree() {
		const [orgs, configs, assets] = await Promise.all([
			await this.api.GetOrganizations(),
			await this.api.GetAllConfigs(),
			await this.api.GetAllAssets(),
		]);
		for (const org of orgs as any) {
			org.id = "org" + org.organization_id;
			const orgconfigs = configs.filter(item => item.organization_id === org.organization_id);
			org.children = orgconfigs;
			for (const config of orgconfigs as any) {
				config.id = "cfg" + config.asset_type_id;
				config.name = config.asset_type_name;
				config.assets = assets.filter(item => item.asset_type_id === config.asset_type_id);
			}
		}
		this.treenodes = orgs;
	}

	public async ActivateNode(node: TreeNode) {
		node.expand();
		if (node.id.startsWith("cfg")) {
			this.selectedConfig = undefined;
			const config = node.data;
			const acqs = await this.api.GetAssetAcqCounts(config.asset_type_id, config.assets.map(item => item.asset_id));
			for (let i = 0; i < config.assets.length; i++) {
				config.assets[i].acqcount = acqs[i];
			}
			this.selectedConfig = node.data;
			await this.UpdateThresholds();
		}
	}

	public async UpdateThresholds() {
		this.thresholdComponents = undefined;
		this.thresholdError = undefined;
		this.selectedComponent = undefined;
		this.newConfig = undefined;
		const selectedAssets = this.selectedConfig.assets.filter(item => item.checked);
		if (selectedAssets.length === 0) {
			this.thresholdComponents = null;
			return;
		}
		try {
			const result = await this.api.GetThresholdData(this.selectedConfig.asset_type_id, selectedAssets.map(item => item.asset_id));
			this.thresholdComponents = result.components;
			this.selectedComponent = this.thresholdComponents[0];
			this.UpdateComponent(this.thresholdComponents[0]);
			this.newConfig = result.xml;
		} catch (err) {
			const message = err.error ? err.error.message : err.message;
			this.thresholdError = message;
		}
	}

	public async UpdateComponent(comp: APIResults.ComponentThreshold) {
		const selectedAssets = this.selectedConfig.assets.filter(item => item.checked);
		const categories = selectedAssets.map(item => item.asset_name);
		this.boxPlotOptions = this.charting.BoxPlotDefaults("Revised HI", categories, comp.stats, comp.outliers);
	}

	public async UploadConfig() {
		await this.api.UpdateConfig(this.selectedConfig.asset_type_id, this.newConfig);
	}
}

interface AssetConfigWithAssets extends APIResults.AssetConfig {
	assets: AssetSelectableWithAcqCount[];
}

interface AssetSelectableWithAcqCount extends APIResults.Asset {
	acqcount: number;
	checked: boolean;
}
